const categoryImages = {
  20: 'catamaran',
  21: 'Gullet',
  45: 'motor_yacht',
  41: 'sailing_yacht',
}

export const getCategoryImage = (category)=>{
    if(category == null){
        return '/assets/icons/svg/Boat_16x16.svg';
    }

    return '/assets/boattypes/' + categoryImages[category] + '.svg';
}
